
// export const api_URL = "http://10.100.5.101:8094/api/",
// export const api_URL = "http:ipm-bis:8094/api/",
// export const api_URL = "http://dd-elite:8094/api/";
// export const api_URL = "http://192.168.12.24:8092/api/";
// baseURL: "https://portail.ipm-africmanagement.com/office/api/",
// export const api_URL = "https://portail.ipmpetitecote.com/office/api/";
export const api_URL = "https://portail.ipmfadiou.com/office/api/";
// export const api_URL = "https://portail.ipmics.com/office/api/";
// export const api_URL = "https://portail.ipmanep.com/office/api/";
// export const api_URL = "https://portail.mutuelle-artisans-sn.com/office/api/";
// baseURL: "https://portail.ipmsagam.com/office/api/",
// baseURL: "https://portail.ipmipres.com/office/api/",
// baseURL: "https://portail.ipmubipharm.com/office/api/",
// export const api_URL = "https://portail.ipmeiffage.com/office/api/";
